<template>
  <div class="info-button-update" @click="update">
    内容を更新
  </div>
</template>

<script>
import MixinResultHandler from '@/components/MixinResultHandler'
export default {
  mixins: [ MixinResultHandler ],
  methods: {
    update: async function () {
      const result = await this.$store.dispatch('info/saveInfo')
      this.showSnackAndMove(result)
    }
  }
}
</script>

<style lang="scss" scoped>
.info-button-update {
  @include button-ol-warning;
}
</style>
